import { render, staticRenderFns } from "./VCardMapDetail.vue?vue&type=template&id=0831ba8a"
import script from "./VCardMapDetail.vue?vue&type=script&lang=js"
export * from "./VCardMapDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0831ba8a')) {
      api.createRecord('0831ba8a', component.options)
    } else {
      api.reload('0831ba8a', component.options)
    }
    module.hot.accept("./VCardMapDetail.vue?vue&type=template&id=0831ba8a", function () {
      api.rerender('0831ba8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/pos/components/complements/VCardMapDetail.vue"
export default component.exports